export const escapeCsvValue = (value: unknown): string => {
  if (value === null || value === undefined) {
    return '';
  }

  const stringValue =
    typeof value === 'string' ? value : (JSON.stringify(value) ?? '');

  if (
    stringValue.includes('"') ||
    stringValue.includes(',') ||
    stringValue.includes('\n') ||
    stringValue.includes('\r')
  ) {
    return `"${stringValue.replace(/"/g, '""')}"`;
  }

  return stringValue;
};

export const buildCsvBlob = <T>(
  rows: T[],
  headers: string[],
  rowMapper: (row: T) => unknown[]
): Blob => {
  const headerLine = headers.join(',');
  const dataLines = rows.map(row =>
    rowMapper(row).map(escapeCsvValue).join(',')
  );

  return new Blob([[headerLine, ...dataLines].join('\n')], {
    type: 'text/csv;charset=utf-8;',
  });
};
